module.exports = __webpack_public_path__ + "img/kaart.fd869d9a.png";